module.exports = __webpack_public_path__ + "static/media/question_icon.277bbc62.svg";